import DegreeProgramEdit from "."
import { reactRouterNestedAncestors, reactRouterParameters } from "storybook-addon-remix-react-router"

export default {
  title: "Pages/DegreeProgram/Edit",
  component: DegreeProgramEdit,
}

const Template = () => {
  return (
    <DegreeProgramEdit />
  )
}

function buildDegreeProgramRecord(id, clientId, name, attrs = {}) {
  return {
    type: "degree-programs",
    id: id,
    attributes: {
      name: name,
      ...attrs
    },
    relationships: {
      client: { data: { type: 'clients', id: clientId } },
    }
  }
}

function buildParameters() {
  return {
    reactRouter: reactRouterParameters({
      location: {
        pathParams: {
          clientId: '1',
          degreeProgramId: '2'
        }
      },
      routing: reactRouterNestedAncestors([
        { path: 'clients' },
        { path: ':clientId' },
        { path: 'degree-programs' },
        { path: ':degreeProgramId'},
      ]),
    }),
    orbit: {
      user: {
        accessibleClientIds: ['1'],
      },
      records: [
        buildDegreeProgramRecord('2', '1', 'Dental Assistant', { programCode: 'DA', lpContinueUrl: 'https://www.somewhere.com', status: 'active'})
      ].filter(Boolean),
    },
  }
}

const Default = {
  render: Template,
  parameters: {},
}

export const ClientUser = {
  ...Default,
  parameters: buildParameters(),
}
